import { getGenericImageObjectAsync } from '@bingads-webui-campaign/image-experience-utils';

export default getGenericImageObjectAsync;
